export function normalizeMojibake(value: string): string {
  if (!value) return value;

  // If the replacement character is already present, remove it first.
  let output = value.replace(/\uFFFD/g, "");

  // Common mojibake pattern for UTF-8 decoded as Latin-1 (Ð..., Ñ...).
  if (!/[ÐÑ]/.test(output)) {
    return output;
  }

  try {
    const bytes = new Uint8Array(
      Array.from(output).map((char) => char.charCodeAt(0) & 0xff),
    );
    const decoded = new TextDecoder("utf-8", { fatal: false }).decode(bytes);

    // Keep decoded value only if it looks better.
    if (decoded && decoded !== output) {
      output = decoded.replace(/\uFFFD/g, "");
    }
  } catch {
    // Keep original output if decoding fails.
  }

  return output;
}

export function normalizeNullableText(
  value: string | null | undefined,
  fallback = "",
): string {
  if (value == null) return fallback;
  return normalizeMojibake(String(value));
}
